import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { getConsent, setConsent } from '../utils/analytics';
import { useTranslation } from '../i18n';

export const CookieConsent: React.FC = () => {
  const t = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner only if the user hasn't made a choice yet
    if (getConsent() === null) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setConsent('accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    setConsent('declined');
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-3 lg:p-4 animate-slide-up">
      <div className="max-w-lg mx-auto pixel-card bg-[#1a101f]/95 backdrop-blur-sm border border-theme/30 p-3 lg:p-4 flex flex-col gap-3">
        {/* Header */}
        <div className="flex items-center gap-2">
          <Cookie className="w-4 h-4 lg:w-5 lg:h-5 text-theme" strokeWidth={2.5} />
          <h3 className="text-[9px] lg:text-xs font-bold text-theme uppercase tracking-wider">
            {t.cookieNotice}
          </h3>
        </div>

        {/* Description */}
        <p className="text-[8px] lg:text-[10px] leading-relaxed text-gray-300">
          {t.cookieDescription}
        </p>

        {/* Buttons */}
        <div className="flex gap-2">
          <button
            onClick={handleAccept}
            className="flex-1 pixel-border bg-theme/40 hover:bg-theme/60 text-theme font-bold uppercase tracking-widest text-[8px] lg:text-xs p-2 lg:p-3 transition-all"
          >
            {t.cookieAccept}
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 pixel-border bg-gray-800/40 hover:bg-gray-700/60 text-gray-400 font-bold uppercase tracking-widest text-[8px] lg:text-xs p-2 lg:p-3 transition-all"
          >
            {t.cookieDecline}
          </button>
        </div>
      </div>
    </div>
  );
};
